import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

// Environment
import { environment } from "@environments/environment";

// Services
import {
  UserService,
  ResourceService
} from "@services/index.service";

// Interfaces
import { ResponseDataBase } from '@interfaces/index.interface';

//Constants
import { AppConstants } from '@app/appConstants';

/** Muestra diferente información para usuarios registrados o no. Si el usuario no está logueado se le explica la opción 
 * y se le invita a loguearse. Cuando el usuario esta logueado se le muestra un formulario a rellenar. 
 * Cuando lo hace y se envía, la información del formulario y del usuario que lo ha enviado se manda a un mail 
 * (configurable desde el environment). Al mismo tiempo se le envia un mail al usuario recordandole que debe enviar 
 * la transferencia antes de recibir la segunda opinión. */
@Component({
  selector: 'app-secondopinion',
  templateUrl: './secondopinion.page.html',
  styleUrls: ['./secondopinion.page.scss']
})
export class SecondopinionComponent implements OnInit {

  secondOpinionForm: FormGroup;
  /** Especialidades para rellenar el combo del formulario */
  specialities;
  alertOk;
  alertError;
  loading;
  secondOpinionData: any = {
    departmentId: null,
    specialityId: null,
    subject: null,
    whatWrong: null,
    sinceWhen: null,
    whatAttribute: null,
    howBegan: null,
    symptoms: null,
    intensity: null,
    whatChange: null
  };

  constructor(public _userService: UserService,
    public _resourceService: ResourceService) {
    /** Al iniciar iniciamos el formulario y cogemos la información necesaria para los combos de hospital y departamentos. */
    this.secondOpinionForm = new FormGroup({
      'department': new FormControl(),
      'speciality': new FormControl(),
      'subject': new FormControl(),
      'whatWrong': new FormControl(),
      'sinceWhen': new FormControl(),
      'whatAttribute': new FormControl(),
      'howBegan': new FormControl(),
      'symptoms': new FormControl(),
      'intensity': new FormControl(),
      'whatChange': new FormControl()
    });
    if (!this._resourceService.departments.length) {
      this._resourceService.getResource('hospitals')
        .subscribe(data => {
          let response = data as ResponseDataBase;
          this._resourceService.hospitals = response.result;
          let params = {
            hospitalId: this._resourceService.hospitals[0].id,
          };
          this._resourceService.getResourceWithParams('departments', params)
            .subscribe(data => {
              let response = data as ResponseDataBase;
              this._resourceService.departments = response.result;
              this._resourceService.loading = false;
            });
          this._resourceService.loading = false;
        });
    }
  }

  /** Rellenamos los especialidades dependiento del departamento elegido. De momento esta hardcodeado.*/
  getSpecialities(departmentId) {
    this.specialities = [{ "id": "", "name": "" }, { "id": "1", "name": "Fake Unit 1" }, { "id": "2", "name": "Fake Unit 2" }, { "id": "3", "name": "Fake Unit 3" }]
  }

  /** TODO esta función debería comprobar que el formulario tiene toda la información necesario y sólo entonces pasarla
   * a la siguiente función
  */
  validateForm() {
    this.askSecondOpinion();
  }

  /** Sacamos los textos necesarios para configurar los mails del environment, y mandamos con le información del formulario, que 
   * formateamos antes con la siguiente funcion, tanto el mail al hospital como al usuario.
   */
  askSecondOpinion() {
    if (environment.SECONDOPINION.HAS) {
      let textForHospital = this.formatTexForMail(this.secondOpinionForm.value);
      let textForUser = environment.SECONDOPINION.MESSAGEFORUSER;
      let dataForHospital = {
        textForMail: textForHospital,
        email: environment.MAILTOCOMUNICATIONS,
        subjectForMail: environment.SECONDOPINION.SUBJECTFORHOSPITAL
      }
      let dataForUser = {
        textForMail: textForUser,
        email: this._userService.user.email,
        subjectForMail: environment.SECONDOPINION.SUBJECTFORUSER
      }
      this._resourceService.sendMail(dataForUser).subscribe(data => { });
      this._resourceService.sendMail(dataForHospital).subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
          this.alertOk = 'THANKS_FOR_ASK_FOR_SECOND_OPINION';
        } else {
          this.alertError = response.METADATA.ERROR_MESSAGE
        }
        window.scrollTo(0, 0);
        this._resourceService.loading = false;
      });
    }
  }

  /** Damos forma a toda la información que tenemos, tanto del usuario como la sacada del formulario*/
  formatTexForMail(textForMail) {
    let formatText = '<p>The user</p>' +
      JSON.stringify(this._userService.user) +
      '<p>Send this Second opinion request from the web</p>' +
      JSON.stringify(textForMail);
    return formatText
  }

  /** Eliminamos toda la información que tenemos en el formulario */
  resetForm() {
    this.secondOpinionData = {
      departmentId: null,
      specialityId: null,
      subject: null,
      whatWrong: null,
      sinceWhen: null,
      whatAttribute: null,
      howBegan: null,
      symptoms: null,
      intensity: null,
      whatChange: null
    };

  }

  ngOnInit() {
  }

}
